import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  VIZ,
  MAX_BAR_THICKNESS,
  axisStyle,
  tooltipStyle,
  valueLabelPlugin,
  formatNumber,
  legendStyle,
} from '../chartTheme';

/**
 * Ranked horizontal bars for a single nominal series (locations, diagnoses,
 * professions...). One series means one hue - never a value-ramp, which would
 * just re-encode the bar length as colour. Horizontal so long names stay level.
 */
export default function RankedBarChart({ labels, data, seriesLabel = 'Patients', valueFormatter = formatNumber }) {
  return (
    <Bar
      data={{
        labels,
        datasets: [
          {
            label: seriesLabel,
            data,
            backgroundColor: VIZ.sequential,
            hoverBackgroundColor: '#1c5cab',
            maxBarThickness: MAX_BAR_THICKNESS,
            borderRadius: 4,
            borderSkipped: 'start',
          },
        ],
      }}
      plugins={[valueLabelPlugin(valueFormatter)]}
      options={{
        indexAxis: 'y',
        maintainAspectRatio: false,
        layout: { padding: { right: 36 } },
        scales: {
          x: { ...axisStyle(true), beginAtZero: true, ticks: { ...axisStyle().ticks, maxTicksLimit: 5 } },
          y: {
            ...axisStyle(false),
            ticks: {
              ...axisStyle().ticks,
              autoSkip: false,
              callback(value) {
                const label = String(this.getLabelForValue(value) ?? '');
                return label.length > 22 ? `${label.slice(0, 21)}…` : label;
              },
            },
          },
        },
        plugins: {
          // One series, one hue - the legend names what the bars count.
          legend: legendStyle(),
          tooltip: tooltipStyle(valueFormatter),
        },
      }}
    />
  );
}
